import React, { ReactNode } from "react";
import FlexBox from "../../../../Components/FlexBox/FlexBox";
import Typography from "../../../../Foundation/Typography/Typography";
import { IThemeMode } from "../../../../Themes/defaultTheme";
import EmailRegister, {
  IEmailRegisterProps,
} from "../../EmailRegister/EmailRegister";
import FooterItem from "../../FooterItem/FooterItem";

interface IFooterNewsProps extends IEmailRegisterProps {
  caption?: ReactNode;
  title?: ReactNode;
  mode?: IThemeMode;
}

const FooterNews = ({
  caption,
  title = "Recevez nos actualités",
  mode = "dark",
  ...emailRegisterProps
}: IFooterNewsProps) => {
  return (
    <FooterItem title={title} mode={mode}>
      <FlexBox direction="column" gap={22}>
        <EmailRegister mode={mode} {...emailRegisterProps} />
        {caption && (
          <Typography variant="ui4" color="greyText">
            {caption}
          </Typography>
        )}
      </FlexBox>
    </FooterItem>
  );
};

export default FooterNews;
